module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Damphreux-Lugnez_COA-5a85886779f00fcebadde19bc5dc8e0c.svg";